import React from 'react';
import PropTypes from 'prop-types';
import {grey700} from "material-ui/styles/colors";
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from "material-ui/RaisedButton";
import {addTenantToQuery} from 'core/common/utils/utils';
import {SplitButton, DropdownButton} from "react-bootstrap";
import securityService from 'core/security/securityService';

import "core/components/buttons/buttons.less";
import {MODULE, SECURABLE_TYPE, ISECURABLE, PERMISSION, SecurableComponentProps} from "core/metamodel/metaConstant";
import {disabledHoc, withDeleteDialogHoc} from "core/security/component/disabledHoc";



/* **************************************************************************************
 *******     ZzFlatButtonRoute     *******************************************************
 ****************************************************************************************/

const ZzFlatButtonRoute__styleOnToolbar = {
  padding: 0,
  margin: 0
};

const ZzFlatButtonRoute__styleOnGridToolbar = {
  padding: 0,
  margin: 0,
  color: grey700
};



export class ZzFlatButtonRoute extends React.Component<any, undefined> {
  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  onClick = (event) => {
    event.preventDefault();
    const {routeName, params, query} = this.props;
    this.context.router.transitionTo(routeName, params, query);
  };

  render() {
    let {routeName, params, query, style, disabled, onToolbar, onGridToolbar, permission, securableType, securable, module,  children, ...other} = this.props;

    const _style = (style && onGridToolbar) ? Object.assign({}, ZzFlatButtonRoute__styleOnGridToolbar, style) : (  onGridToolbar ? ZzFlatButtonRoute__styleOnGridToolbar : style );

    if (!securityService.hasRouterRight(this.context.router, module, securableType, securable, permission)) {
      return <noscript/>
    }



    return (disabled) ? (
      <FlatButton onClick={this.onClick} disabled style={_style} {...other} >
        {children}
      </FlatButton>
    ) : (
      <a href={this.context.router.makeHref(routeName, params, addTenantToQuery(query))} onClick={this.onClick}>
        <FlatButton style={_style} {...other}>
          {children}
        </FlatButton>
      </a>
    );

  }

}


/* **************************************************************************************
 *******     ZzSplitButton     *******************************************************
 ****************************************************************************************/

interface ZzSplitButtonProps {
  primary?: boolean;
  secondary?: boolean;
  title?: string;
  disabled?: boolean;
  onClick?: Function;
  children?: any;
  id?: string;
  bsStyle?: string;
}

export const ZzSplitButton = ({primary, secondary, title, disabled, onClick, children, id, bsStyle}: ZzSplitButtonProps) => {
  return (
    <SplitButton bsStyle={bsStyle || "zz"} disabled={disabled} onClick={onClick} title={title.toUpperCase()} id={id}>
      {children}
    </SplitButton>
  );
};


/* **************************************************************************************
 *******     ZzDropdownButton     *******************************************************
 ****************************************************************************************/


export const ZzDropdownButton = ({primary, secondary, onToolbar, title, disabled, onClick, children, id}) => {
  return (
    <DropdownButton bsStyle="zz"  disabled={disabled} onClick={onClick} title={title.toUpperCase()} id={id}>
      {children}
    </DropdownButton>
  );
};


/* **************************************************************************************
 *******     ZzFlatButton     *******************************************************
 ****************************************************************************************/

export const ZzFlatButton = ({module, securableType, securable, permission, detailId, ...other}: SecurableComponentProps & {[label:string]:any}) => {
  return (
    <FlatButton {...other} />
  );
};

export const SecuredZzFlatButton = disabledHoc(FlatButton);
export const SecuredZzRaisedButton = disabledHoc(RaisedButton);

export const WithDeleteDialogZzFlatButton = withDeleteDialogHoc(FlatButton);

/* **************************************************************************************
 *******     ZzUploadFlatButton     *******************************************************
 ****************************************************************************************/

const uploadStyles: any = {
  uploadButton: {
    verticalAlign: 'middle',
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
};

export class ZzUploadFlatButton extends React.Component<SecurableComponentProps & {[label:string]:any}, null> {

  onChange = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    this.props.handleFileUpload(files);
  };

  onClick = (event) => {
   event.target.value = null;
  };


  render() {
    let {module, securableType, securable, permission, style, handleFileUpload, accept, disabled, ...other} = this.props;

    style = (style) ? Object.assign({}, uploadStyles.uploadButton, style) : uploadStyles.uploadButton;

    return (
      <FlatButton labelPosition="before" containerElement='label' style={style} disabled={disabled} {...other}>
        <input type="file" disabled={disabled} style={uploadStyles.uploadInput} onChange={this.onChange} onClick={this.onClick} accept={accept}/>
      </FlatButton>
    );
  }

}


export const SecuredZzUploadFlatButton = disabledHoc(ZzUploadFlatButton);


//



// WEBPACK FOOTER //
// ./src/core/components/buttons/buttons.tsx